/**
 * Ticket Status Constants
 */
export const TICKET_STATUS = {
  NEW: "NEW",
  PAUSED: "PAUSED",
  IN_PROGRESS: "IN_PROGRESS",
  ORDERED: "ORDERED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  CLOSED: "CLOSED",
  NOT_REACHED: "NOT_REACHED",
  CONVERSATION_DONE: "CONVERSATION_DONE",
} as const;

/**
 * Ticket Priority Constants
 */
export const TICKET_PRIORITY = {
  LOW: "LOW",
  MEDIUM: "MEDIUM", 
  HIGH: "HIGH",
} as const;

/**
 * UI Display Constants
 */
export const TICKET_UI_DEFAULTS = {
  STATUS: "NEW", // UI display value for new tickets
  PRIORITY: "LOW", // Default priority
} as const;